import { generateUUID } from '@/tools/helpers';
import { logger } from '@/tools';

// ##################
let timeSyncUrl = 'https://time.cms.shoutrlabs.com'; // this is overwritten with [datasourceURL]/time.php
const maxSyncAttempts = 20; // Attempts to request time from sync server.
// const minSyncAttempts = 6;
const maxRountripDurationInit = 0.5; // in s; Max accepted time for a roundtrip for requesting the time from the sync server.
const maxRountripDurationStep = 0.3; // seconds to increase duration if sync fails
const maxRountripDurationMax = 1.5; // absolute max rountrip duration in s
let maxRountripDuration = maxRountripDurationInit;
const maxTimeSyncErrors = 10;
// const percentTimeCorrectionCloseToMedian = 0.2; // percentage that time correction is allowed to be away from the median
let syncronizing = false;
// ##################

export function now() {
	return Date.now() / 1000;
}

// FIXME replace this with vue function
function xhrGet(url) {
	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();
		xhr.open('GET', url, true);
		xhr.overrideMimeType('text/plain');
		xhr.onload = () => {
			if (xhr.status === 200) {
				resolve(xhr.response);
			} else {
				reject(new Error(`${xhr.status} ${xhr.statusText}`));
			}
		};
		xhr.onerror = () => {
			reject(new Error(`Network error ${xhr.status}`));
		};
		xhr.send();
	});
}

async function getOneSyncServerTimeCorrection() {
	const beforeFetch = now();
	const result = await xhrGet(`${timeSyncUrl}?cacheBreaker=${generateUUID()}`);
	const serverTime = parseFloat(result) / 1000; // in seconds
	const roundTripDuration = now() - beforeFetch;
	const timeCorrection = now() - serverTime - roundTripDuration / 2;
	if (roundTripDuration > maxRountripDuration) {
		throw Error(`Connection to slow, rountrip took ${roundTripDuration.toFixed(2)} s.`);
	}
	return {
		roundTripDuration,
		timeCorrection,
	};
}

// function median(values) {
// 	values.sort((a, b) => a - b);
// 	const half = Math.floor(values.length / 2);
// 	if (values.length % 2) return values[half];
// 	return (values[half - 1] + values[half]) / 2.0;
// }

// function filterTimeCorrectionCloseToMedian(values) {
// 	const medianTimeCorrection = median(values);
// 	return values.filter(_timeCorrection => {
// 		const difference = _timeCorrection / medianTimeCorrection;
// 		return (
// 			difference < 1 + percentTimeCorrectionCloseToMedian &&
// 			difference > 1 - percentTimeCorrectionCloseToMedian
// 		);
// 	});
// }

// function arithmeticAverage(values) {
// 	return values.reduce((acc, value) => acc + value, 0) / values.length;
// }

function sortSyncResults(a, b) {
	return a.roundTripDuration <= b.roundTripDuration ? -1 : 1;
}
// function mapTimeCorrectionValues({ timeCorrection }) {
// 	return timeCorrection;
// }

async function _syncTime(progressFunction) {
	logger.log('syncTime');
	// in seconds
	const results = [];
	let errors = 0;
	while (results.length < maxSyncAttempts) {
		try {
			results.push(await getOneSyncServerTimeCorrection());
		} catch (error) {
			logger.log('time sync error', error);
			if (++errors > maxTimeSyncErrors) {
				throw new Error(`Syncronization failed. Last error: ${error}`);
			}
		}
		progressFunction(Math.round(results.length / (maxSyncAttempts / 100)));
	}
	errors = 0;
	// const firstN = 3;
	results.sort(sortSyncResults);
	logger.log('results', results);
	// const _timeCorrection =
	// 	results.slice(0, firstN).reduce((acc, { timeCorrection }) => acc + timeCorrection, 0) / firstN;
	// logger.log(`_timeCorrection of first ${firstN} average ${_timeCorrection}`);
	// Use the time correction from the lowest round trip time
	let _timeCorrection = 0;
	let nrOfUsedVals = 6;
	for (let i = 0; i < nrOfUsedVals; i++) {
		_timeCorrection += results[i].timeCorrection;
	}
	_timeCorrection = _timeCorrection / nrOfUsedVals; // mean of 5 best values
	// const _timeCorrection = results[0].timeCorrection;
	// logger.log('taking shortest roundTripDuration',results[0].roundTripDuration);
	if (isNaN(_timeCorrection)) {
		throw new Error('Time correction is NaN.');
	}
	return _timeCorrection;
}

export async function syncronizeServerTime({ progressFunction, serverTimeSyncUrl }) {
	if (syncronizing) {
		throw new Error('Server time syncronization is already in progress.');
	}
	if (serverTimeSyncUrl) timeSyncUrl = serverTimeSyncUrl;
	let timeCorrection;
	try {
		syncronizing = true;
		timeCorrection = await _syncTime(progressFunction);
		syncronizing = false;
	} catch (error) {
		logger.warn(`${error}`);
		if (maxRountripDuration < maxRountripDurationMax) {
			maxRountripDuration += maxRountripDurationStep;
			throw new Error('Das Synchronisieren hat nicht funktioniert. Bitte versuche es erneut.');
		} else {
			throw new Error(
				'Deine Internetverbindung ist zu langsam. Bitte nimm Kontakt zum Organisationsteam auf.'
			);
		}
	}
	logger.log('timeCorrection', timeCorrection);
	// timeServerSyncErrors = 0;
	maxRountripDuration = maxRountripDurationInit;
	return timeCorrection;
}
